const ElPopover = ELEMENT.Popover;
const mounted = ElPopover.mounted;
const destroyed = ElPopover.destroyed;

let on = function (element, event, handler) {
  if (element && event && handler) {
    element.addEventListener(event, handler, false);
  }
}

let off = function (element, event, handler) {
  if (element && event && handler) {
    element.removeEventListener(event, handler, false);
  }
}

ElPopover.mounted = function () {
  mounted.call(this);
  if (this.trigger === 'click') {
    let scorllEl = this._scorllEl = dsf.findScrollEl(this.$el);
    on(document.body, 'wheel', this.handleDocumentWheel);
    on(scorllEl, 'scroll', this.handleDocumentWheel);
  }
}

ElPopover.destroyed = function () {
  destroyed.call(this);
  off(document.body, 'wheel', this.handleDocumentWheel);
  off(this._scorllEl, 'scroll', this.handleDocumentWheel);
  this._scorllEl=null
}

ElPopover.methods.handleDocumentWheel = function (e) {
  if (!this.showPopper) return;
  const popper = this.popper || this.$refs.popper;
  let popoverDom = $(e.target).closest('.el-popover').get(0);
  if (popper !== popoverDom) {
    this.doClose();
  }
}